<hb-userlane></hb-userlane>
<hb-header></hb-header>
<div class="app-body">
  <hb-sidebar></hb-sidebar>
  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <ol id="breadcrumbs" *ngIf="UserAuthenticated" class="breadcrumb">
      <hb-breadcrumbs></hb-breadcrumbs>
    </ol>
    <hb-spinner></hb-spinner>
    <hb-session-timeout></hb-session-timeout>
    <div class="main-container">
      <div>
        <router-outlet name="contextual-actions"></router-outlet>
      </div>
      <router-outlet></router-outlet>
      <p-toast id="notification-toast" position="bottom-right" [style]="{ marginTop: '42px' }" [baseZIndex]="zIndexPopover"></p-toast>
    </div>
    <!-- /.conainer-fluid -->
  </main>
  <hb-aside></hb-aside>
</div>
